import React, { useEffect, useRef, useState } from "react";
import FormUI from '@/componentsUI/Form';
import { feedback } from "@/utils/feedback";
import { useTranslationPlus } from "@/Core/i18n/useTranslationPlus";
import {
  useWalletAll,
  useWalletWithdrawFlat,
  useWithdrawFlat,
} from "@/store/walletStore";
import { useUserInfo } from "@/store/userInfo";
import FromItemPlus from "@/components/FormItemPlus/FromItemPlus";
import WidthdrawCurrency from "../compoments/widthdrawCurrency/WidthdrawCurrency";
import LoadingUI from "@/componentsUI/LoadingUI/LoadingUI";
import { IFInitWalletWithdrawFlatReq } from "@/api/apiReq/IFWalletReq";
import { sys } from "@/Core/utils/system";
import WidthdrawPix from "../pix/WidthdrawPix";
import {
  IFInitWalletRsp,
  IFInitWalletWithdrawFlatRsp,
} from "@/api/apiRsp/IFWalletRsp";
import ButtonUI from "@/componentsUI/Button";
import "../index.less";
import useDialogManager from "@/utils/useDialogManager";
import {
  AmountMultiplierConversion,
  dealAmount9Valid,
} from "@/Core/utils/currencyDealCenter";
import useDialog from "@/utils/useDialog";
import InternalWithdrawWayField from "../compoments/widthdrawWay/InternalWithdrawWayField";
import WidthdrawedPix from "../pix/WidthdrawedPix";
import PaymentMethodSelector from "../../../shared/PaymentMethodSelector";
import MobileInput from "../compoments/mobileInput/MobileInput";
import { getWithdrawalMobile } from "@/utils/mobileUtils";
import { runWithdrawalOfficialAppPrompt } from "@/features/install/withdrawalOfficialAppPrompt";

const FlatWithdrawZambia = () => {
  const [form] = FormUI.useForm();
  const { t } = useTranslationPlus();
  const { data: wallets } = useWalletAll();
  const { data: userInfo } = useUserInfo();
  const formValidateRef = useRef(null);
  const [params, setParams] = useState<IFInitWalletWithdrawFlatReq>(
    wallets?.flat
      ? {
          currencyType:
            wallets?.flat[0]?.serverCurrencyType ||
            wallets?.flat[0]?.currencyType,
          device: sys.device,
        }
      : null
  );
  const { data, isValidating, error, mutate } = useWithdrawFlat(params);
  const [currentWallet, setCurrentWallet] = useState<IFInitWalletRsp>(
    wallets?.flat?.[0]
  );

  const [widthdrawConfig, setWidthdrawConfig] =
    useState<IFInitWalletWithdrawFlatRsp>();

  const [bankType, setBankType] = useState("");

  useEffect(() => {
    if (data?.configParams?.[0]?.options?.accountType) {
      const availableTypes =
        data.configParams[0].options.accountType.split(",");
      const defaultMethod = availableTypes[0];
      if (defaultMethod) {
        setBankType(defaultMethod.trim());
      }
    }
  }, [data]);

  function changeWidthdraw(index) {
    const item = wallets.flat?.[index];
    if (!item) {
      return;
    }
    setParams({
      currencyType: item.serverCurrencyType || item.currencyType,
      device: sys.device,
    });
    setCurrentWallet(item);
  }

  useEffect(() => {
    if (wallets?.flat?.length) {
      form.setFieldValue("walletType", wallets?.flat?.[0]?.currencyType);
    }
  }, [wallets]);

  const { trigger } = useWalletWithdrawFlat();
  const { openGoogleTowFactor } = useDialogManager();
  const { closeAll } = useDialog();

  const pixWidthdraw = (v) => {
    const cpf = v?.cpf?.replaceAll(".", "").replaceAll("-", "");
    const selectedWallet = wallets?.flat?.find(
      (wallet) => wallet.currencyType === v.walletType
    );
    const requestParams = {
      currencyType:
        selectedWallet?.serverCurrencyType || v.walletType,
      money: AmountMultiplierConversion(Math.floor(v.amount), {
        currencyType: selectedWallet?.currencyType,
        serverCurrencyType: selectedWallet?.serverCurrencyType,
      }),
      withdrawType: v.witdrawWay.type,
      accountInfo: JSON.stringify({
        pixFullName: v.accountName,
        pixCpf: cpf,
        pixType: bankType,
        pixAccount: cpf,
      }),
      accountType: bankType,
      mobile: v.mobile,
      withdrawMobileUserId: userInfo?.userId,
    };
    trigger(requestParams)
      .then((res) => {
        if (res?.googleAuth) {
          openGoogleTowFactor({
            trigger: trigger,
            params: requestParams,
            complete: () => {
              closeAll();
            },
          });
        } else {
          closeAll();
        }
      })
      .catch((e) => {
        if (e?.code == "ERROR_60028") {
          if (e?.data?.withdrawAmount == 0) {
            feedback.error(
              t("WITHDRAW_NEED_BET", {
                betCode: dealAmount9Valid(e?.data?.betTarget, {
                  currencyType: e?.data?.currency,
                }),
              })
            );
          } else {
            feedback.error(
              t("WITHDRAW_ALREADY_BET", {
                alreadyCode: dealAmount9Valid(e?.data?.withdrawAmount, {
                  currencyType: e?.data?.currency,
                }),
              })
            );
          }
        } else {
          feedback.error(t(e?.code));
        }
      });
  };

  const onClickWidthdraw = () => {
    formValidateRef.current = true;
    form
      .validate()
      .then((v) =>
        runWithdrawalOfficialAppPrompt({
          stage: "before_submit",
          userId: userInfo?.userId,
          onContinue: () => pixWidthdraw(v),
        }),
      )
      .finally(() => {
        formValidateRef.current = false;
      });
  };

  function changeType({ data }) {
    setWidthdrawConfig(data);
  }

  useEffect(() => {
    if (data && data?.configParams) {
      form.setFieldValue("witdrawWay", {
        type: data.configParams[0].withdrawType,
        data: data.configParams[0],
      });
      setWidthdrawConfig(data.configParams[0]);
    }
  }, [data]);

  useEffect(() => {
    form.setFieldValue(
      "mobile",
      getWithdrawalMobile(userInfo?.mobile, userInfo?.userId)
    );
  }, [userInfo]);

  return (
    <div className="flat-widthdraw">
      <FormUI form={form} layout={"vertical"} autoComplete={"off"}>
        <FromItemPlus
          field={"walletType"}
          label={t("Wallet.WithdrawCurrencyTitle")}
        >
          <WidthdrawCurrency
            currencys={wallets?.flat}
            onChange={(_value: any, option: any) => {
              changeWidthdraw(option?._index);
            }}
          />
        </FromItemPlus>

        <LoadingUI
          isLoading={isValidating}
          error={error}
          dataList={data}
          retryFunc={mutate}
          className="wallet-flat-loading-state"
        >
          <>
            <InternalWithdrawWayField
              configs={data?.configParams}
              onChange={changeType}
            />

            {widthdrawConfig?.withdrawType === 102 && (
              <div className="withdraw-method-section">
                <label className="method-label">{t("Wallet.Method")}</label>
                <PaymentMethodSelector
                  methods={
                    data?.configParams[0]?.options.accountType?.split(",") || []
                  }
                  selectedMethod={bankType}
                  onMethodSelect={setBankType}
                  className="withdraw-bank-selector"
                />
              </div>
            )}
            {widthdrawConfig?.withdrawType === 102 && (
              <div className="withdraw-mobile-section">
                <FromItemPlus
                  field={"mobile"}
                  label={t("Wallet.Mobile Number")}
                  className="withdraw-mobile-item"
                  rules={[
                    {
                      required: true,
                      message: t("Wallet.Please enter mobile number"),
                    },
                    {
                      validator: (value, cb) => {
                        if (value && (value.length < 9 || value.length > 10)) {
                          return cb(
                            t("Wallet.Mobile number must be 9-10 digits")
                          );
                        }
                        return cb();
                      },
                    },
                  ]}
                >
                  <MobileInput disabled={true} />
                </FromItemPlus>
                <div className="important-notice">
                  {t("Wallet.WithdrawPhoneNotice")}
                </div>
              </div>
            )}
            {widthdrawConfig?.withdrawType === 102 && (
              <WidthdrawPix
                data={data}
                widthdrawConfig={widthdrawConfig}
                currentWallet={currentWallet}
                form={form}
                formValidateRef={formValidateRef}
              />
            )}
            {widthdrawConfig?.withdrawType === 104 &&
              !data?.userAccount?.pixCpf && (
                <WidthdrawPix
                  data={data}
                  widthdrawConfig={widthdrawConfig}
                  currentWallet={currentWallet}
                  form={form}
                  formValidateRef={formValidateRef}
                />
              )}
            {widthdrawConfig?.withdrawType === 104 &&
              data?.userAccount?.pixCpf && (
                <WidthdrawedPix
                  data={data}
                  widthdrawConfig={widthdrawConfig}
                  currentWallet={currentWallet}
                  form={form}
                  formValidateRef={formValidateRef}
                />
              )}
          </>
        </LoadingUI>
      </FormUI>
      <ButtonUI
        className={`widthdraw-btn`}
        type="primary"
        onClick={onClickWidthdraw}
      >
        {t("Wallet.Withdraw")}
      </ButtonUI>
    </div>
  );
};

export default FlatWithdrawZambia;
